var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-asap-workflow-summary"},[_c('app-table-details',{attrs:{"rows":_vm.rows,"data":_vm.summary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }